import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { fetchCategories } from '../store';

const useCategories = () => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.category.loading);
  const data = useSelector((state) => state.category.data);
  const error = useSelector((state) => state.category.error);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  return { loading, data, error };
};

export default useCategories;
